import React from 'react';

export const onClientEntry = () => {
  globalThis.React = React;
  import('netlify-identity-widget');
};
